module.exports = __webpack_public_path__ + "static/media/rc-pro-eweiss-2020.d0cd9cdf.pdf";